module.exports = __webpack_public_path__ + "static/img/ent-26.f8df687.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-26.jpg
// module id = dqr1
// module chunks = 51